import React, {useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import {Input} from 'antd'
import Heading from 'components/shared/Heading'
import Button from 'components/shared/Button'
import SearchResult from './SearchResult'

const CadastreSearch = ({onSelect, tabs, initialSearch = {}}) => {
  const [input, setInput] = useState(initialSearch)
  const [showResult, setShowResult] = useState(false)

  const inputUpdated = (evt) => {
    const value = evt.target.value
    const name = evt.target.name
    setInput({...input, [name]: value})
    setShowResult(false)
  }

  const performSearch = () => {
    setShowResult(true)
  }

  const addressSelected = (address) => {
    setInput({})
    setShowResult(false)
    onSelect(address)
  }

  // Since there is a button to perform a search, we only want to run when the
  // component is mounted. If we want live reloading in matrikkel search we can
  // change the empty array to be `[input]`
  useEffect(() => {
    if (input.knr && input.gnr && input.bnr) {
      performSearch()
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="cadastre-search">
      <Heading level={3}>Matrikkelnummer</Heading>

      <div className="input-group">
        <div className="cadastre-inputs">
          <Input
            size="large"
            name="knr"
            onChange={inputUpdated}
            value={input.knr}
            placeholder="Knr"
          />
          <span>/</span>
          <Input
            size="large"
            name="gnr"
            onChange={inputUpdated}
            value={input.gnr}
            placeholder="Gårdsnr"
          />
          <span>/</span>
          <Input
            size="large"
            name="bnr"
            onChange={inputUpdated}
            value={input.bnr}
            placeholder="Bruksnr"
          />
          <Button
            size="large"
            type="action"
            onClick={performSearch}
          >
            Finn objekt
          </Button>
        </div>

        {tabs}
      </div>

      {showResult && (
        <SearchResult
          cadastreId={input}
          onSelect={addressSelected}
        />
      )}
    </div>
  )
}

CadastreSearch.propTypes = {
  onSelect: PropTypes.func,
}

export default CadastreSearch
